import { ContactGroup } from "./ContactGroup"
import { ContactWidgetProps } from "./types";

export const Notes: React.FC<ContactWidgetProps> = ({ id }) => {
  return <ContactGroup id={id} title="Notes" fields={["notes"]} />;
};